import { PortalRedirect, PortalRedirectContextProvider } from "@switch/portal";
import Api from "../Api";

export const PortalRedirectLoader = () => {


    const API = new Api(
        {
            urlRoot: window.location.origin + "/Dispace/Switch/1.0.0/BookingRequest/",
            widgetKey: "nokey"
        });

    return (<PortalRedirectContextProvider API={API}>
        < PortalRedirect />
    </ PortalRedirectContextProvider >

    );
}